// extracted by mini-css-extract-plugin
module.exports = {"goToTheVault":"VaultHighlights_goToTheVault__161qn"};